export const QA_NAME_USER_PROFILE_NAME = 'userName'

export const QA_NAME_USER_SIGN_OUT = 'userSignOut'
